/* eslint-disable no-nested-ternary */
import { styled, css } from 'styled-components';

import { RuleProps } from './types';

export const RuleList = styled.ul`
  font: var(--font-body-small--regular);
  display: grid;
  gap: var(--spacing-2);
`;

export const RuleWrapper = styled.li`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  line-height: 1.2em;
`;
export const RuleIcon = styled.span<Pick<RuleProps, 'isValid' | 'isTouched'>>`
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  aspect-ratio: 1;
  height: 1em;
  padding: var(--spacing-1);
  border-radius: 50%;
  color: var(--color-white);

  > * {
    width: 100%;
    height: 100%;
  }

  ${({ isTouched, isValid }) =>
    isTouched
      ? isValid
        ? css`
            background-color: var(--color-numa-green--100);
          `
        : css`
            background-color: var(--color-numa-red--100);
          `
      : css`
          background-color: var(--color-numa-black--100);
        `};
`;
